<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <p-carousel
      [value]="items"
      [numVisible]="1"
      [numScroll]="1"
      [circular]="true"
      showIndicators="false">
      <ng-template let-data pTemplate="item">
        <div>
          <!-- <app-video-thumbnail
            [videoUrl]="data.value.url"></app-video-thumbnail>
          <div
            class="font-bold mt-2 text-lg text-center"
            [attr.style]="buildStyle('text', data.styles?.text)">
            {{ data.value.videoTitle }}
          </div> -->
          <div class="text-center mt-1">
            <iframe width="100%" 
            height="250" referrerpolicy="strict-origin-when-cross-origin" [src]="getSafeUrl(data.value.url)" frameborder="0"></iframe>
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </div>
</div>
